import React from "react";
import { withRouter } from "react-router-dom";
import { TableOp } from "../../../components/table/TableOps.tsx";
import TableComponent from "../../../components/table/TableOps";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Input } from "@material-ui/core";
import ContraRecibo from "./ContraRecibo";
import ACCESS from "../../../ACCESS.js";
// import Factura from "./PagoFacturas";

class ContraRecibos extends TableComponent {
  componentDidMount() {
    this.tableConfig(
      {
        dataUrl: `contra-recibo/filter`,
        deleteUrl: "nota-credito/delete",
        deleteField: "id",
        modUrl: "/cobranza/nota-credito",
      },
      TableOp.Table(
        false,
        [
          { label: "Folio", id: "tipo_cons" },
          { label: "Cliente", id: "cliente_rsocial" },
          { label: "Importe", id: "importe" },
          { label: "Fecha", id: "createdAt" },
          { label: "Recibido", id: "recibida" },
        ],
        [
          { id: "add", icon: "add", cb: this.onContraRecibo, access: [ACCESS.COBRANZA_CONTRA_RECIBO.CREAR_CONTRARECIBO] },
          // { id: 'delete', icon: 'delete' },
        ]
      )
    );
    this.table();
  }

  toNote = () => {
    this.props.history.push('/cobranza/nota-credito/');
  }

  onGuiaFolioChange = (val) => {
    this.setState({ guiaFolio: val });
  }

  onSearchFolio = () => {
    const { guiaFolio = "" } = this.state;
    if (guiaFolio.length < 1) return;
    this.tableConfig(
      {
        dataUrl: `contra-recibo/filter?folio=${guiaFolio}`,
        deleteUrl: "nota-credito/delete",
        deleteField: "id",
        modUrl: "/cobranza/nota-credito",
      },
      this.state.tableData
    )
    this.table()
  }

  onContraRecibo = (id, row) => {
    console.log(id, row)
    this.setState({ crDialog: { visible: true, row } });
  }

  onContraReciboClose = () => {
    this.setState({ crDialog: { visible: false } });
  }

  onContraReciboSave = () => {
    this.setState({ crDialog: { visible: false } });
    this.table();
  }

  render() {
    const { guiaFolio = "", crDialog = { visible: false } } = this.state;
    return (
      <div className="row">
        <div className="col-sm-12" style={{ textAlign: 'right' }}>
          <Input value={guiaFolio} onChange={(e) => this.onGuiaFolioChange(e.target.value)} />
          <Button onClick={this.onSearchFolio} variant="contained" color="primary">
            Buscar folio
          </Button>
        </div>
        <div className="col-sm-12">
          <this.TableRender />
        </div>

        <Dialog
          onClose={this.onContraReciboClose}
          open={crDialog.visible}
          fullWidth={true}
          maxWidth={"xl"}
        >
          <DialogTitle onClose={this.onContraReciboClose}>Factura</DialogTitle>
          <DialogContent dividers>
            <ContraRecibo factura={crDialog.row} onSave={this.onContraReciboSave} />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.onContraReciboClose}>Cerrar</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withRouter(ContraRecibos);